import http from "./http-common";

class UserDataService {
  //Used in :
  //ProfileList -> retrieveUser()
  //SponsorList -> retrieveUsers()
  getAll(params) {
    return http.get("/user", {
      params,
    });
  }

  getAllGarUsers() {
    return http.get("/user/findAllGarUser");
  }

  //Used in :
  //Register ->  isUsernameAvailable()
  isUsernameAvailable(params) {
    return http.get("/user/isUsernameAvailable", { params });
  }
  isSSOSessionValid() {
    return http.get("/user/isSSOSessionValid");
  }
  //Used in :
  //Register ->  isEmailAvailable()
  isEmailAvailable(params) {
    return http.get("/user/isEmailAvailable", { params });
  }

  getUserWithUsername(username) {
    return http.get(`/user/findUserWithUsername/${username}`);
  }

  getAllTeamUsers(teamId) {
    return http.get(`/user/findAllTeamUsers/${teamId}`);
  }

  //Used in :
  //ActivityList -> dbGetUserInformation()
  //SequenceList -> dbGetUserInformation()
  //ProfileEdit -> dbGetUserInformation()
  //Create -> dbGetUserInformation()
  getUserInfos(id) {
    return http.get(`/user/findUserInfos/${id}`);
  }

  getUserProfileInfos(id) {
    return http.get(`/user/findUserProfileInfos/${id}`);
  }

  getUserActivities(id) {
    return http.get(`/user/findUserActivities/${id}`);
  }

  getUserActivitiesLength(id) {
    return http.get(`/user/findUserActivitiesLength/${id}`);
  }

  getUserSharedActivities(id) {
    return http.get(`/user/findUserSharedActivities/${id}`);
  }
  /*
  getUserSequences(id) {
    return http.get(`/user/findUserSequences/${id}`);
  }
*/
  getUserTeams(id) {
    return http.get(`/user/findUserTeams/${id}`);
  }

  getUserGarDivs(id) {
    return http.get(`/user/findUserGarDivs/${id}`);
  }

  getUserGarGros(id) {
    return http.get(`/user/findUserGarGros/${id}`);
  }

  getUserGarDivsAndGrosSequences(id) {
    return http.get(`/user/findUserGarDivsAndGrosSequences/${id}`);
  }
  /*
getUserGarGroups(id) {
    return http.get(`/user/findUserGarGroups/${id}`);
  }

  getUserGarGroupsSequences(id) {
    return http.get(`/user/findUserGarGroupsSequences/${id}`);
  }
*/

  getUserGarGroups(id) {
    return http.get(`/user/findUserGarGroups/${id}`);
  }

  getUserGarGroupsSequences(id) {
    return http.get(`/user/findUserGarGroupsSequences/${id}`);
  }

  getUserAll(id) {
    return http.get(`/user/findUserAll/${id}`);
  }

  getEstablishmentInfos(uai) {
    return http.get(`/user/getEstablishmentInfos/${uai}`);
  }

  updateUserRole(id, role) {
    return http.get(`/user/updateUserRole/${id}/${role}`);
  }

  addFollower(userId, followerId) {
    return http.get(`/user/addFollower/${userId}/${followerId}`);
  }

  removeFollower(userId, followerId) {
    return http.get(`/user/removeFollower/${userId}/${followerId}`);
  }

  getFollowers(userId) {
    return http.get(`/user/getFollowers/${userId}`);
  }

  getFollowersCount(userId) {
    return http.get(`/user/getFollowersCount/${userId}`);
  }

  getTotalActivitiesPlays(userId) {
    return http.get(`/user/getTotalActivitiesPlays/${userId}`);
  }

  getTotalActivitiesImports(userId) {
    return http.get(`/user/getTotalActivitiesImports/${userId}`);
  }

  getUserTopTags(userId) {
    return http.get(`/user/getUserTopTags/${userId}`);
  }

  getFavorites(userId) {
    return http.get(`/user/getFavorites/${userId}`);
  }

  addFavorite(userId, activityId) {
    return http.get(`/user/addFavorite/${userId}/${activityId}`);
  }

  removeFavorite(userId, activityId) {
    return http.get(`/user/removeFavorite/${userId}/${activityId}`);
  }

  //Not used
  create(data) {
    return http.post("/user", data);
  }

  createGuestUser(data) {
    return http.post("/user/createGuestUser", data);
  }

  //Used in :
  //CreateFirstConnection -> dbUdateUserTutorialDisplayed()
  //ProfileEdit -> updateUserInfos()
  update(id, data) {
    return http.put(`/user/${id}`, data);
  }

  updateSubscription(id, data) {
    return http.put(`/user/sub/${id}`, data);
  }

  updateTeamSubscription(id, data) {
    return http.put(`/user/teamSub/${id}`, data);
  }

  //Used in :
  //ProfileList -> dbRemoveOneUser()
  delete(id) {
    return http.delete(`/user/${id}`);
  }

  //Not used
  deleteAll() {
    return http.delete(`/user`);
  }

  deleteAllUsersWithUai(uai) {
    return http.delete(`/user/deleteAllUsersWithUai/${uai}`);
  }

  deleteAllStudentUsersWithUai(uai) {
    return http.delete(`/user/deleteAllStudentUsersWithUai/${uai}`);
  }

  deleteAllTeacherUsersWithUai(uai) {
    return http.delete(`/user/deleteAllTeacherUsersWithUai/${uai}`);
  }

  sendMailToAllUsersWithUai(uai) {
    return http.get(`/user/sendMailToAllUsersWithUai/${uai}`);
  }

  deleteSeancesOfAllUsersWithUai(uai) {
    return http.delete(`/user/deleteSeancesOfAllUsersWithUai/${uai}`);
  }
}

export default new UserDataService();
